import React, { Component } from "react";

import ApiContext, { defaultContext as defaultApiContext } from "../api";
import Routes from "routes/routes";
import { ThemeProvider } from "@mui/material/styles";
import { AuthProvider } from "context/AuthContext/AuthProvider";
import { customMuiTheme } from "../theme/material-ui/material.theme";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "../theme/fonts/custom-fonts.scss";
import { ptBR } from "@mui/x-date-pickers/locales";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const brasilLocale =
  ptBR.components.MuiLocalizationProvider.defaultProps.localeText;

export default class App extends Component {
  render() {
    return (
      <AuthProvider>
        <ThemeProvider theme={customMuiTheme}>
          <LocalizationProvider
            dateAdapter={AdapterMoment}
            adapterLocale="pt-br"
            localeText={brasilLocale}
          >
            <ApiContext.Provider value={defaultApiContext}>
              <Routes />
            </ApiContext.Provider>
          </LocalizationProvider>
          <ToastContainer />
        </ThemeProvider>
      </AuthProvider>
    );
  }
}
